import Vue from 'vue';
import Router from 'vue-router';
import NoAccess from './components/NoAccess';
import Journal from './components/EmpfangsportalOverview';
import Suche from './components/SucheOverview';
import DocumentSingleView from './components/DocumentSingleView';

import store from './store'

/*global wpData:true*/
/*eslint no-undef: "error"*/
const appPath = `/${wpData.app_path}`;

const nonce = wpData.nonce;
const restURL = wpData.rest_url

Vue.use( Router );

/**
 * Each route should map to a component.
 * The "component" can either be an actual component or just a component options object.
 */

let router = new Router({
	base: appPath, // path of the SPA relative to the domain.
	mode: 'hash', // or "history"
	routes: [
		{
			path: '/noAccess',
			name: 'NoAccess',
			component: NoAccess,
			meta: { 
				title: 'Empfangsjournal | Konto - VALI-E',
				customer: false
			}
		},
		{
			path: '/',
			name: 'Journal',
			component: Journal,
			meta: {
				title: 'Empfangsjournal | Konto - VALI-E',
				customer: true
			}
		},
		{
			path: '/document',
			name: 'DocumentSingleView',
			component: DocumentSingleView,
			meta: { 
				title: 'Empfangsjournal | Konto - VALI-E',
				customer: false
			}
		},
		{
			path: '/archivsuche',
			name: 'Archivsuche',
			component: Suche,
			meta: {
				title: 'Archivsuche | Konto - VALI-E',
				customer: false
			}
		},
		// {
		// 	path: '*',
		// 	redirect: { name: 'Empfangsjournal | Konto - portinvoice' }
		// }
	],
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
	document.title = to.meta.title
	var customer = to.meta.customer
    var data = { 'nonce': nonce, 'restURL': restURL, 'customer': customer }
    store.dispatch('isPortinvoiceLoggedIn', data)
    .then(resp => {
		next()
    })
	.catch(err => {
		next()
	})
})

// router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.requiresAuth)) {
//         if (store.getters.isLoggedIn) {
//             next()
//             return
//         }
//         next('/notLoggedIn')
//     // } else if (to.matched.some(record => record.meta.loggedIn)) {
//     //     if (store.getters.isLoggedIn) {
//     //         next('/education')
//     //         return
//     //     }
//     //     next()
//     } else {
//         next()
//     }
// })


// router.beforeEach((to, from, next) => {

//     //if (to.matched.some(record => record.meta.requiresAuth)) {

//     var data = { 'nonce': nonce, 'restURL': restURL }
//     store.dispatch('isLoggedIn', data)
//     next()

//     //} else {
//         //next()
//     //}
// })

export default router

/*
 * Note: Turning on the HTML5 History Mode with "mode: 'history'" will eliminate the '#' in the URLs. However, as we're loading Vue on a Custom Page Template, the main routing is still handled by WordPress. As a result a page refresh of directly loading a Vue specific link will return 404 Not Found.
 * With the '#' in the URL the Vue specific link will work as regular link.
 * e.g.
 * http://wpvue.test/search-page/#/videos will work directly or even on page refresh but
 * http://wpvue.test/search-page/videos will not as WordPress will try to look for it.
 */



// WEBPACK FOOTER //
// ./src/app-routes.js